import { render, staticRenderFns } from "./NavImage.vue?vue&type=template&id=4b588ef4&scoped=true&"
import script from "./NavImage.vue?vue&type=script&lang=js&"
export * from "./NavImage.vue?vue&type=script&lang=js&"
import style0 from "./NavImage.vue?vue&type=style&index=0&id=4b588ef4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b588ef4",
  null
  
)

export default component.exports